import React, { FC, useState, useEffect } from 'react';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  fetchNonProspectSurveyResults,
  fetchNonProspectSurveySummary,
} from 'src/app/modules/Survey/network/surveyCrud';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import { SurveyResult, SurveySummaryResult } from 'src/app/modules/Survey/types/survey-types';
import NonProspectSurveyAnalyticSection from './component/NonProspectSurveyAnalyticSection';
import { LayoutSplashScreen } from 'src/app/layout';

const NonProspectSurveyAnalyticPage: FC<RouteComponentProps> = ({ history, location }) => {
  const { id } = useParams<{ id: string }>();

  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [surveyResults, setSurveyResults] = useState<SurveyResult>();
  const [surveySummaries, setSurveySummary] = useState<SurveySummaryResult>();

  const reloadData = async () => {
    try {
      if (id) {
        setIsLoading(true);
        const surveyResult = await fetchNonProspectSurveyResults(id, dispatch);
        const surveySummary = await fetchNonProspectSurveySummary(id, dispatch);

        setSurveyResults(surveyResult);
        setSurveySummary(surveySummary);
      }
    } catch (e) {
      history.push(NOT_FOUND_ERROR_PAGE_PATH);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    reloadData();
    // eslint-disable-next-line
  }, [id]);

  return (
    <>
      {isLoading || !surveyResults || !surveySummaries ? (
        <LayoutSplashScreen />
      ) : (
        <NonProspectSurveyAnalyticSection results={surveyResults} summaries={surveySummaries} />
      )}
    </>
  );
};

export default NonProspectSurveyAnalyticPage;
